import { render, staticRenderFns } from "./Evoting.vue?vue&type=template&id=33553702&"
import script from "./Evoting.vue?vue&type=script&lang=js&"
export * from "./Evoting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports